<template>
    <b-container fluid class="px-3">
        <b-row>
            <b-col>
                <l-map v-if="loaded" :zoom="zoom" :center="center" ref="map" style="height: 20rem">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                    <div class="custom-officer-legend">
                        <div class="legend-item">
                            <div class="legend-color" style="background-color: red;"></div>
                            <div class="legend-label">{{ $translate('gtn5_incompleted_activities') }}</div>
                        </div>
                        <div class="legend-item">
                            <div class="legend-color" style="background-color: #FFBF00;"></div>
                            <div class="legend-label">{{ $translate('ltn6togtn0_incompleted_activities') }} </div>
                        </div>
                        <div class="legend-item">
                            <div class="legend-color" style="background-color: green;"></div>
                            <div class="legend-label">{{ $translate('no_incompleted_activities') }}</div>
                        </div>
                        <!-- Add more legend items as needed -->
                    </div>
                    <l-control class="map-custom-control">
                        <dashboard-filters key="officer" :title="$translate('officers')" :roles="rolesOptions"
                            :officers="OfficerOptions" @select-officer="selectedOfficer = $event"
                            @select-role="selectedRole = $event" :filters="['location-role', 'location-officer']" />


                    </l-control>
                    <v-marker-cluster :options="clusterOptions">
                        <l-marker v-for="(officer, index) in formattedOfficers" :key="index" :lat-lng="officer.latlng"
                            :radius="officer.radius" :color="officer.orders_incompleted"
                            :fill-color="officer.orders_incompleted" @mouseover="showPopup($event.target)"
                            :icon="officerIcon(officer.orders_incompleted)">
                            <l-popup :autoClose="false">
                                <span class="popup_header">{{ officer.name }}</span><br />
                                <span class="popup_label">{{ $translate('incomplete_total') }}:</span>{{
                                    officer.orders_incompleted }}<br />
                                <span class="popup_label">{{ $translate('incomplete_value') }}:</span>{{
                                    officer.total_incomplete_value | formatCurrency
                                }}<br />
                                <span class="popup_label">{{ $translate('completed_total') }}:</span>{{
                                    officer.orders_completed }}<br />
                                <span class="popup_label">{{ $translate('completed_value') }}:</span>{{
                                    officer.total_completed_value | formatCurrency
                                }}<br />
                                <a :href="officer.id | formatPath">{{ $translate('view_activities') }}</a>
                            </l-popup>
                        </l-marker>
                    </v-marker-cluster>

                    <l-geo-json :geojson="geojson"></l-geo-json>
                </l-map>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import graphMixins from '@/mixins/graphMixins'
import DashboardFilters from '@/views/Dashboard/DashboardFilters'
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LGeoJson,
    LControl,
} from 'vue2-leaflet'
import L from 'leaflet'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
const defaultLocation = L.latLng(18, -77.2)
const incompleteQry = '/#/ams/activities?page=1&query=&changed=0&entity=1'

export default {
    name: 'officers-map',
    components: {
        'v-marker-cluster': Vue2LeafletMarkerCluster,
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LGeoJson,
        LControl,
        DashboardFilters,
    },
    mixins: [graphMixins],
    props: {
        officers: {
            type: Array,
            default: () => [],
        },
        roles: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: () => defaultLocation,
        },
        loaded: {
            type: Boolean,
            default: () => false,
        },
        geojson: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            zoom: 8,
            url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
            clusterOptions:{
                iconCreateFunction: cluster => {
                    var childCount = cluster.getChildCount();
                    var c = " marker-cluster-";
                    if (childCount < 10) {
                        c += "small";
                    } else if (childCount < 100) {
                        c += "medium";
                    } else {
                        c += "large";
                    }
                    let className={
                        red: 0,
                        amber: 0,
                        green: 0
                    }
                
                    // Assuming your data is stored in cluster.getAllChildMarkers()
                    const clusterMarkers = cluster.getAllChildMarkers();

                    clusterMarkers.forEach(marker => {

                        const orders_completed = marker.options.icon.options.orders_incompleted;
                        
                        // Rest of your code for counting and determining cluster color
                        if (orders_completed == 0) className.green += 1;
                        else if (orders_completed <= 5 && orders_completed > 0) className.amber += 1;
                        else className.red += 1;
                    });

                    // Determine the cluster color based on counts
                    let iconColor;
                    // lower incompleted activity count
                    if(className.green > 0){
                        iconColor='green-cluster'
                    }
                    // higher incompleted activity count
                    if(className.amber > 0){
                        iconColor='amber-cluster'
                    }
                    // highest incompleted activity count
                    if(className.red > 0){
                        iconColor='red-cluster'
                    }
                    return new L.DivIcon({
                        html: "<div><span>" + childCount + "</span></div>",
                        className: `marker-cluster ${c} ${iconColor}`,
                        iconSize: new L.Point(40, 40)
                    });
                },
            }
        }
    },
    filters: {
        formatCurrency(val) {
            const currencyFormatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            })
            return currencyFormatter.format(val)
        },
        formatPath(id) {
            return incompleteQry + '&driver_id=' + id + '&is_from_dashboard=1'
        },
    },
    computed: {
        formattedOfficers() {
            const role_id = this.selectedRole
            const officer_id = this.selectedOfficer
            const officers = this.getOfficers(role_id, officer_id)
            return officers.filter(order => order.orders_count > 0).map(_officer => {
                console.log('_officer.total_value', _officer.total_value)

                _officer.total_incomplete_value =
                    _officer.total_value - _officer.total_completed_value

                _officer.orders_incompleted =
                    _officer.orders_count - _officer.orders_completed
                _officer.radius = 8

                const { latitude, longitude } = this.setCoordinate(_officer)
                _officer.latlng = new L.latLng(
                    parseFloat(latitude),
                    parseFloat(longitude)
                )
                return _officer
            })
        },
        center() {
            const count = this.formattedOfficers.length
            if (count === 0) return defaultLocation
            const s = this.formattedOfficers.reduce(
                (sum, officer) => {
                    const { latitude, longitude } = this.setCoordinate(officer)
                    sum.latitude = sum.latitude + latitude
                    sum.longitude = sum.longitude + longitude
                    return sum
                },
                {
                    latitude: 0,
                    longitude: 0,
                }
            )
            let latitude = 0,
                longitude = 0
            if (count > 0) {
                latitude = s.latitude / count
                longitude = s.longitude / count
            }
            latitude = this.$store.state.company.settings.latitude
            longitude = this.$store.state.company.settings.longitude
            return new L.latLng(latitude, longitude)
        },
    },
    watch: {
        loaded: function (val) {
            if (val) {
                const $this = this
                this.$nextTick(() => {
                    const map = $this.$refs.map.mapObject
                    map.addControl(new L.Control.Fullscreen())

                })
            }
        },
    },
   
    methods: {
        showPopup(marker) {
            marker.openPopup()
        },
        setCoordinate({ longitude, latitude }) {
            longitude = parseFloat(longitude) || -77.2
            latitude = parseFloat(latitude) || 18
            return { longitude, latitude }
        },

        showAlert() {
            alert('Click!')
        },
        officerIcon(orders_incompleted) {
            let iconColor
            if (orders_incompleted > 5) {
                iconColor = 'red'
            } else if (orders_incompleted > 0) {
                iconColor = '#FFBF00'
            } else {
                iconColor = 'green'
            }
            return L.divIcon({
                html: `<i class="fas fa-user-tie fa-2x" style="color: ${iconColor};"></i>`,
                orders_incompleted
                // iconSize: [100, 100], // Adjust the size of the icon as needed
                // You can customize other icon properties here, such as iconAnchor, popupAnchor, etc.
            })
        },

        getOfficers(role_id, officer_id) {
            if (!role_id && !officer_id) return this.officers
            else if (officer_id)
                return [this.officers.find(x => x.id === officer_id)]

            const $this = this
            return this.officers.filter(x => $this.isOfficerInRole(x, role_id))
        },
    },
}
</script>

<style>
.autocomplete input {
    border-radius: 0;
}

.leaflet-div-icon {
    background: none;
    border: none;
}

#map.fullscreen {
    z-index: 9;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
}

#map {
    height: 418px;
    z-index: 0;
}

.map-custom-control {
    background: #fff;
    padding: 0 0.5em;
    border: 1px solid #aaa;
    border-radius: 0.1em;
}

dl {
    display: grid;
    grid-template-columns: max-content auto;
}

dt {
    grid-column-start: 1;
}

dd {
    grid-column-start: 2;
}

.popup_header {
    text-decoration: underline;
    font-weight: bold;
}

.popup_label {
    font-weight: bold;
}

.custom-officer-legend {
    position: absolute;
    bottom: 10px;
    /* Adjust the position as needed */
    left: 10px;
    /* Adjust the position as needed */
    background-color: rgba(255, 255, 255, 0.8);
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    z-index: 1000;
}

.legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.legend-color {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

.legend-label {
    font-size: 14px;
}</style>
